import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query($order: [ProfitSharingsFindOrder!],$where: ProfitSharingsFindFilter) {\n    exportProfitSharingsList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query($order: [ProfitSharingsFindOrder!], $paging: PagingQuery, $where: ProfitSharingsFindFilter) {\n    findProfitSharings(\n      order: $order,\n      paging: $paging,\n      where: $where\n    ) {\n      profitSharings {\n        id\n        transactionNumber\n        profitSharingNumber\n        timeEnd\n        createdAt\n        status\n        totalPrice\n        order {\n          id\n          orderNumber\n          totalPrice\n          createdAt\n          dealer {\n            realname\n            user {\n              phone\n            }\n          }\n        }\n      }\n      paging {\n        currentOffset\n        take\n        totalCount\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var findProfitSharings = gql(_templateObject());
export var exportProfitSharingsList = gql(_templateObject2());